<template>
<div>
  <!-- Main jumbotron for a primary marketing message or call to action -->
  <div class="jumbotron">
    <div class="container">
      <h1 class="display-6">软件简介</h1>
      <p>第三方服务提供商：企业为维持核心能力将组织的非核心业务委托给外部的专业公司，降低营运成本，集中人力资源和设备满足市场需求。这里的第三方服务提供商就是指接受此类业务委托的企业，它的客户就是上游进行业务外包的企业。</p>
      <p>第三方服务提供商企业项目追踪软件，以
        <router-link to='/valueView/theory'>“蔡格尼克效应”</router-link>
        为理论基础，致力于帮助第三方服务提供商企业改善现状。它内嵌了考勤系统和工作流功能，将考勤数据和工作流数据纳入到改善现状的基础数据，极大提高企业投入产出比，可以帮助客户容易并且迅速达到标准化流程作业，并有效跟踪项目，提高客户满意度，是第三方服务提供商企业为加强项目管理，放眼未来扩大市场的一款软件。</p>
      <p><router-link class="btn btn-primary btn-lg" to='/valueView/theory'>了解更多</router-link></p>
    </div>
  </div>

  <div class="container">
    <!-- Example row of columns -->
    <div class="row">
      <div class="col-md-12" style="border: 1px;">
        <div style="float:left; margin:10px;">
        <p><img src="../../static/assets/image/phone.jpg"/></p>
        </div>
        <p><b>现状一：</b>项目负责人Tiger每天都会接听来自客户的电话，问询关于项目的进展情况，需要多久可以完成或者是否能够按时完成，项目现在进展的什么阶段，项目是否遇到任何问题等等。</p>
        <p>每次接听都感到头皮发麻，因为他要花很多时间去查询客户项目信息，何时外包，项目预期完成时间，紧急程度如何，此外项目目前停留在什么阶段是他最难以回答的问题，因为有些项目是跨部门的，甚至他自己也不清楚。</p>
        <p>特别另他感到不安的是，如果这次没能明确回答客户的询问，客户的询问频率会增加，询问的内容也会越来越详细。Tiger几乎要崩溃了。</p>
        <p><router-link class="btn btn-secondary btn-lg" to='/valueView/detail'>详细信息 &raquo;</router-link></p>
      </div>
      <div class="col-md-12">
        <div style="float:right; margin:10px;">
        <p><img src="../../static/assets/image/complain.jpg"/></p>
        </div>
        <p><b>现状二：</b>Tiger作为项目负责人在接受来自客户的外包任务后，首先要手工填写外包任务信息，而这些任务信息还需要在任务流转表，工单表重复填写；</p>
        <p>另外Tiger要根据客户要求给出任务完成时间，有的是普通五天的任务，有加急的三天任务，还有需要当天完成的特急任务，Tiger可以参考的信息很少，比如考勤信息，实施人员任务负载，设备空闲状态等等，他只好按照客户要求接收任务，然后将任务分派给实施人员并告知紧急程度。</p>
        <p>然而当客户来取任务结果的时候，Tiger发现实施人员把普通任务完成了，而紧急任务没有做，客户非常不满向经理投诉，Tiger受到了经理的批评。</p>
        <p><router-link class="btn btn-secondary btn-lg" to='/valueView/detail'>详细信息 &raquo;</router-link></p>
      </div>
      <div class="col-md-12">
        <div style="float:left; margin:10px;">
        <p><img src="../../static/assets/image/confuse.png"/></p>
        </div>
        <p><b>现状三：</b>Lion是任务的实施人员，在他手里已经有十几张派工单，里面夹杂着不同紧急程度的任务，完成日期也不一样，每个任务需要完成的时间也不一样，Lion感到很苦恼，他不知道应该如何对工单进行排序。此外，当紧急任务完成时，他会需要很多精力重新开始进行之前被中断的任务。每次出现漏掉的紧急任务后，Lion都会陷入深深的自责。</p>
        <p><router-link class="btn btn-secondary btn-lg" to='/valueView/detail'>详细信息 &raquo;</router-link></p>
      </div>
      <div class="col-md-12">
        <div style="float:right; margin:10px;">
        <p><img src="../../static/assets/image/annoy.jpg" /></p>
        </div>
        <p><b>现状四：</b>May是一名公司经理，她发现项目返工已经严重影响了项目进度，经过对几个发生返工项目的调查研究，发现不规范的工作流程是造成返工的主要原因，经过团队的头脑风暴，一系列针对不同类型项目的工作流程被制定出来。然而在项目执行过程中，制定好的工作流程并没有被很好的执行，项目返工的问题依旧存在，这让May一直感到苦恼。</p>
        <p><router-link class="btn btn-secondary btn-lg" to='/valueView/detail'>详细信息 &raquo;</router-link></p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="text-align:center;margin: 20px;font-size:2em;">免费服务</div>
      <div id="image" class="col-md-4" :style="'position:relative;height:200px;width:300px;background:url(' + image.src + ') no-repeat 50% 50%;'" v-for="image in images" :key="image.id">
          <p>{{image.title}}</p>
          <span>{{image.content}}</span>
      </div>
    </div>
    <hr>
  </div>
</div>
</template>
<script>
export default {
  name: 'contentView',
  data () {
    return {
      displayImage: 'inline',
      images: [
        { 'id': '1',
          'title': '产品升级',
          'content': '产品模块新功能统一发布，所有用户都可以免费升级新功能。定期发送产品升级信息，有效帮助用户了解对产品升级需要。',
          'src': '../../static/assets/image/product-upgrade-index.png'},
        { 'id': '2',
          'title': '设备集成',
          'content': '预留数据采集接口，多种方式实现系统与设备间的数据采集和交换，大量减少人工数据采集的工作以及采集过程中产生的失误。',
          'src': '../../static/assets/image/instrument-integration-index.png'},
        { 'id': '3',
          'title': '数据安全',
          'content': '系统采用盐加密算法保护，有效保护用户信息不被盗用，也防止从数据库中获取用户密码，保证权限有效分配，加强企业内部管理。',
          'src': '../../static/assets/image/secure-data-access-index.png'},
        { 'id': '4',
          'title': '技术支持',
          'content': '24小时在线支持，采用公司内部开发专用远程协助工具，支持多种操作系统，帮助客户解决系统问题，并协助检验处理业务数据。',
          'src': '../../static/assets/image/technical-support-index.png'},
        { 'id': '5',
          'title': '自动备份',
          'content': '系统数据分布式自动备份，可以避免单个服务器宕机导致数据丢失，系统提供数据恢复功能，尽最大可能保证数据完整性。',
          'src': '../../static/assets/image/automatic-backups-index.png'},
        { 'id': '6',
          'title': '历史数据迁移',
          'content': '免费提供原系统数据迁移服务。',
          'src': '../../static/assets/image/legacy-data-migration-index.png'}
      ]
    }
  },
  methods: {
  },
  created () {

  }
}
</script>

<style scoped>
#image span {
  display:none;
  text-decoration:none
  }
#image:hover span {
  display:block;
  position:absolute;
  font-size: 1.25vh;
  bottom:0;
  left:0px;
  padding: 10px 10px 10px 15px;
  color:#FFF;
  width:100%; 
  z-index:10;
  height:80%;
  line-height:36px;
  text-align:left;
  text-indent: 2em;
  border: 10px;
  background:#666;
  filter:alpha(opacity=60);
  -moz-opacity:0.5;
  opacity: 1;
}
#image p {
  display:none;
  text-decoration:none
  }
#image:hover p {
  display:block;
  position:absolute;
  font-size: 2vh;
  top:0;
  left:0px;
  color:#FFF;
  width:100%; 
  z-index:10;
  height:20%;
  line-height:36px;
  text-align:center;
  border: 10px;
  background:#666;
  filter:alpha(opacity=60);
  -moz-opacity:0.5;
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/ContentView.vue